import { ModalWindow } from "../../components/ModalWindow/ModalWindow";

import { useDispatch } from "react-redux";
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import { closeModal } from "../../store/modalWindowSlice";

export const ModalWindowContainer = () => {
    const dispatch = useDispatch();
    const modalWinProperties = useSelector((state: RootState) => state.modal);
    const classModalWin = modalWinProperties.isOpen? 'modal-win_opened' : '';

    const handleClose = () => {
        dispatch(closeModal());
    }

    return(
        <ModalWindow
        title={modalWinProperties.title}
        message={modalWinProperties.message}
        classNameModal={classModalWin}
        handleCloseModal={handleClose}
        />
    )
}